import React from 'react';
import { DateRangeSection } from './DateRangeSection';
import { TimeRangeSection } from './TimeRangeSection';
import { Alert, Heading, Paragraph, Popover, Popper, Text, ThemeConstellation } from '@zillow/constellation';
import { ThemeProvider } from 'styled-components';
import { Flex } from '@zillow/constellation';

export const HybrydEventsTimeSelection: React.FC = () => {
  return (
    <div className="flex flex-col">
      <section id="dss-time-selection" className="flex flex-row gap-4">
        <DateRangeSection />
        <TimeRangeSection />
      </section>
      <ThemeProvider theme={ThemeConstellation as any}>
        <Alert
          className={'mt-2'}
          body={
            <Flex>
              <Text>
                Select a time range for the appointment between 8am-7pm. The start time is when the first appointment
                can begin, and the end time is when the last appointment must be over.
              </Text>
              <DateTimePopover />
            </Flex>
          }
        />
      </ThemeProvider>
    </div>
  );
};

export const DateTimePopover = () => {
  const popover = (
    <Popover
      renderHeader={<Heading level={6}>Example</Heading>}
      renderBody={
        <React.Fragment>
          <Paragraph>
            If the end time is 3pm, the last available appointment starts at 2pm (appointments are estimated at 1 hour
            for simplicity). Time options are available at the top of the hour (e.g., 9am) and at the half-hour mark
            (e.g., 9:30am).
          </Paragraph>
        </React.Fragment>
      }
    />
  );

  return (
    <Flex display="inline-flex" className="ml-1 align-sub">
      <Popper triggered={popover} />
    </Flex>
  );
};
